


import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Notification, NotificationType } from '../NotificationBanner/NotificationBanner.models';
import { FormFieldData, FormFieldType } from '@/components/FormField/formfield.models';
import FormField from '@/components/FormField/index.vue';
import { Validators, validate } from '@/utils/helpers/validation';

const notifyModule = namespace('notify');
const configurationModule = namespace('configuration');

@Component({
  components: { FormField }
})
export default class LatestCodeDisplay extends Vue {
  @notifyModule.Action private showNotification!: (data: Notification) => void;
  @notifyModule.Action private closeNotification!: (key: string) => Promise<void>;

  @configurationModule.Getter private shareLink!: string;
  @configurationModule.Getter private currentCode!: string;

  private email: FormFieldData = {
    required: true,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    autocompleteTag: 'email',
    validators: [Validators.isEmail()],
    tabbable: true
  };

  private eosum: FormFieldData = {
    required: false,
    value: '',
    type: FormFieldType.Text,
    hasError: false,
    validators: [Validators.maxLength(0)],
    tabbable: false
  };

  private get linkLabel(): string {
    return this.shareLink.replace(/(^\w+:|^)\/\//, '');
  }

  private get formattedCode(): string {
    return (this.currentCode || '').toUpperCase();
  }

  private submitEmail() {
    if (validate(this.email) && validate(this.eosum)) {
      this.$emit('submit-email', this.email);
      this.$gtm.trackSubmitMail();
    } else {
      this.email.hasError = true;

      this.showNotification({
        headline: this.$t('components.latestCode.emailInvalid') as string,
        type: NotificationType.Error,
        origin: 'ConfigCodeDialog',
        key: 'LatestCodeDisplay/emailInvalid'
      });
    }
  }

  private handleEmailFocus() {
    this.email.hasError = false;

    this.closeNotification('LatestCodeDisplay/emailInvalid');
  }

  private async sendToClipboard(text: string) {
    if (!navigator.clipboard) {
      this.sendToClipboardFallback(text);

      return;
    }

    try {
      await navigator.clipboard.writeText(text);
      this.showNotification({
        headline: this.$t('components.latestCode.clipboard') as string,
        type: NotificationType.Success,
        origin: 'ConfigCodeDialog',
        key: 'LatestCodeDisplay/clipboard'
      });
    } catch (error) {
      console.error(error);
    }
  }

  private sendToClipboardFallback(text: string) {
    const textArea = document.createElement('textarea');
    textArea.value = text;
    textArea.style.top = '0';
    textArea.style.left = '0';
    textArea.style.position = 'fixed';
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      document.execCommand('copy');

      this.showNotification({
        headline: this.$t('components.latestCode.clipboard') as string,
        type: NotificationType.Success,
        origin: 'ConfigCodeDialog',
        key: 'LatestCodeDisplay/clipboard'
      });
    } catch (error) {
      console.error(error);
    }

    document.body.removeChild(textArea);
  }
}
